module.exports = __webpack_public_path__ + "img/crush_light_ba_detail_rsh_3.c1a75bf9.jpg";